import React, { createContext, useContext, useState } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

function loadStored() {
  try {
    const raw = localStorage.getItem('inpace_auth');
    if (!raw) return { user: null, token: null };
    const { user, token } = JSON.parse(raw);
    return { user: user || null, token: token || null };
  } catch {
    return { user: null, token: null };
  }
}

export function AuthProvider({ children }) {
  const initial = loadStored();
  const [user, setUser] = useState(initial.user);
  const [token, setToken] = useState(initial.token);

  const login = async (email, password) => {
    try {
      const { token: t, user: u } = await authApi.login(email, password);
      localStorage.setItem('inpace_auth', JSON.stringify({ token: t, user: u }));
      setToken(t); setUser(u);
      return { ok: true };
    } catch (e) {
      const msg = e?.response?.data?.detail || 'Login failed';
      return { ok: false, msg };
    }
  };

  const logout = () => {
    localStorage.removeItem('inpace_auth');
    setToken(null); setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
